import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import { parseTriggerForDisplay } from 'components/schedules-old/trigger-utils'

export function getTimePeriodForInvocationVerbiage(schedule) {
  return parseTriggerForDisplay(schedule.trigger)
}

export default function TimePeriodForInvocation({ schedule, datePrefix }) {
  const verbiage = getTimePeriodForInvocationVerbiage(schedule)

  return schedule.trigger.type === 'Random' ? (
    <div className="column">
      <Text as="small" color="medium" weight="normal">
        <span data-test-schedule-start>{verbiage.start}</span> to{' '}
        <span data-test-schedule-end>{verbiage.end}</span>
      </Text>
    </div>
  ) : (
    <Text as="small" color="medium" weight="normal">
      {datePrefix}
      {verbiage.date} at {verbiage.time}
    </Text>
  )
}

TimePeriodForInvocation.propTypes = {
  schedule: PropTypes.object,
  datePrefix: PropTypes.string
}

TimePeriodForInvocation.defaultProps = {
  datePrefix: 'on '
}
